





























































import {Component, Ref, Vue} from 'vue-property-decorator'
import {CeditForm} from "@/form/CompanyForm";
import companyModule from '@/store/module/CompanyModule';
import EditDialog from "@/component/Crud/edit-dialog.vue";
import CompanyApi from "@/module/device/CompanyApi";
import {Container} from "typescript-ioc";
import Company from "@/model/Company";
import RefreshButton from "@/component/Button/refresh-button.vue";

@Component({
  components: {
    RefreshButton,
    EditDialog
  },
})
export default class CompanyInfoView extends Vue {

  private companyApi = Container.get(CompanyApi)

  @Ref()
  private editDialog!: EditDialog

  private form = new CeditForm()

  private company = new Company()

  private async created() {
    await this.getCompany()
  }

  private async getCompany() {
    let id: number
    if (companyModule.activeOrNull == undefined)
      id = Number(this.$route.query.cid)
    else id = companyModule.active.id
    this.company = await this.companyApi.query(id)
    await companyModule.activate(this.company)
  }

  private refresh() {
    this.getCompany()
  }

  private async beforeOpenEditDialog() {
    this.form.id = this.company.id
    this.form.name = this.company.name
    this.form.fullname = this.company.fullname
    this.form.natureKey = this.company.natureKey
  }

  private async editCompany() {
    const company = await this.companyApi.edit(this.form)
    companyModule.activate(company)
  }
}
